import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { TvSubscription } from '@r1-frontend/ui-react/organisms/TariffSubscription';

import { MainLayout } from '~/src/features/full-buy/containers/MainLayout/MainLayout';
import CombinedContainerForMainPage
    from '~/src/features/full-buy/containers/Subscriptions/CombinedContainerForMainPage';
import skipSubscriptionsStep from '~/src/features/full-buy/store/actions/skipSubscriptionsStep';

export const SubscriptionsPage = ({ className }: { className?: string }): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(skipSubscriptionsStep());
    }, []);

    return <MainLayout className={className}>
        <ListContainer $direction={'column'} $size={24}>
            <CombinedContainerForMainPage />
        </ListContainer>
    </MainLayout>;
};

export default styled(SubscriptionsPage)`
    @media (min-width: ${wideBreakpoints.mobile}) {
        ${TvSubscription} {
            min-height: 100%;
        }
    }
`;
